import { useRequest } from '../providers/useRequest';
import AppError from '../../errors/AppError';
import IDiseaseClassification from '../../interfaces/IDiseaseClassification';

const useDiseaseClassificationService = () => {
  const request = useRequest<IDiseaseClassification>();

  const path = 'disease-classification';

  const list = async (filter: string): Promise<IDiseaseClassification[]> => {
    const url = filter
      ? `${path}?perPage=300&currentPage=1&orderBy=code&orderDirection=ASC&filter=${filter}`
      : `${path}?perPage=300&currentPage=1&orderBy=code&orderDirection=ASC`;
    return await request
      .getManyPaginated({
        path: url,
        sendAuthorization: true,
      })
      .then(result => {
        return result?.data;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  return { list };
};

export { useDiseaseClassificationService };
